import { datadogLogs } from '@datadog/browser-logs';
import store from '@/store';

export default function setGlobalApiEndpoint(vars) {
  // TODO: remove this line after regional rollout final tests
  window.__APP__.DEBUG_REMOVE = vars;
  const tenantId = vars['dp.bid'];
  const employeeId = vars['dp.eid'];
  const userId = vars['dp.uid'];

  store.commit('setTenantId', tenantId);
  datadogLogs.setGlobalContextProperty('tenantId', tenantId);
  datadogLogs.setGlobalContextProperty('employeeId', employeeId);
  datadogLogs.setGlobalContextProperty('userId', userId);

  if (window.__APP__.API_OVERRIDE) {
    window.__APP__.SVC_API = window.__APP__.API_OVERRIDE;
    return;
  }

  window.__APP__.SVC_API = vars['dp.regs']
    ? `https://api.${vars['dp.regs']}.${window.__APP__.API_ENV}.dpty.io/hr/v1`
    : '';
}
